import { render } from "./AttachmentRichText.vue?vue&type=template&id=1038dc60&scoped=true"
import script from "./AttachmentRichText.vue?vue&type=script&lang=js"
export * from "./AttachmentRichText.vue?vue&type=script&lang=js"

import "./AttachmentRichText.vue?vue&type=style&index=0&id=1038dc60&lang=scss&scoped=true"
import "./AttachmentRichText.vue?vue&type=style&index=1&id=1038dc60&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1038dc60"]])

export default __exports__